<template>
	<div _bg="white" _p="x-22px y-10px">
		<div class="ability-detail-header" _m="l-[-12px]" @click="routeBack">
			<i class="el-icon-arrow-left" style="margin-right: 5px;"></i>返回
		</div>
		<div>
			<div>
				<div>课堂常规</div>
				<div>当前评级：A</div>
			</div>
		</div>
	</div>
</template>

<script>
// 对应指标三大类页面
export default {
	data() {
		return {}
	},
	methods: {
		routeBack() {
			const { isJump } = this.$route.query
			if (isJump) {
				this.$router.push(`/workbench/student_mgn`)
			} else {
				this.$router.go(-1)
			}
		}
	},
	mounted() {},
	watch: {}
}
</script>

<style lang="scss" scoped>
.ability-detail-header {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	font-size: 16px;
	cursor: pointer;
}
.ability-detail-header:hover {
	color: #ff5e2a;
}
</style>
